import axios from 'axios'
import api from '..'
import { isNewRelicAgentError, logger } from '../../utils/logger'

export const uploadFiles = async (files: FileList | null | undefined): Promise<string[]> => {
  if (!files) return Promise.resolve([])
  const response = []

  logger.addPageAction('upload_files_start', {
    filesCount: files.length,
    totalSize: Array.from(files).reduce((sum, f) => sum + f.size, 0),
    fileDetails: Array.from(files).map((f) => `${f.name}(${f.size}b,${f.type})`).join(', ')
  })

  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    try {
      const formData = new FormData()
      formData.append('files', file)

      const uploaded = await api.post('auth/customer/upload/files', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      response.push(uploaded.data[0])
    } catch (error) {
      if (isNewRelicAgentError(error)) {
        logger.addPageAction('upload_file_nr_agent_error_ignored', {
          fileIndex: i,
          fileName: file?.name
        })
        continue
      }

      const isNetworkError = axios.isAxiosError(error) && !error.response
      logger.logError(error instanceof Error ? error : new Error('Upload file error'), {
        type: 'upload_file_error',
        isNetworkError,
        fileIndex: i,
        fileName: file?.name,
        fileSize: file?.size,
        fileType: file?.type,
        responseStatus: axios.isAxiosError(error) ? error.response?.status : undefined,
        errorCode: axios.isAxiosError(error) ? error.code : undefined
      })
      throw error
    }
  }

  logger.addPageAction('upload_files_success', {
    filesCount: response.length
  })

  return response
}
